import type { Components, Theme } from "@mui/material";

export const tableCellTheme: Components<Theme>["MuiTableCell"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderBottom: `1px solid ${theme.palette.divider}`,
    }),
    head: ({ theme }) => ({
      color: theme.palette.text.secondary,
      fontSize: "0.75rem",
      fontWeight: 600,
      height: "44px",
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      "&th:first-of-type": {
        paddingLeft: theme.spacing(4),
      },
      "&th:last-of-type": {
        paddingRight: theme.spacing(4),
      },
    }),
    body: ({ theme }) => ({
      "&td:first-of-type": {
        paddingLeft: theme.spacing(4),
      },
      "&td:last-of-type": {
        paddingRight: theme.spacing(4),
      },
    }),
  },
};
